'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_sign_SignView$$anon$16() {
  this.bX7 = null;
  this.bX5 = null;
  this.bX6 = false;
  this.bX3 = null;
  this.bX4 = false;
  this.bX8 = false;
  this.bX9 = false;
  this.bX7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_sign_SignView$$anon$16 as $c_Lpresto_pages_sign_SignView$$anon$16 };
$p = $c_Lpresto_pages_sign_SignView$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_sign_SignView$$anon$16;
/** @constructor */
function $h_Lpresto_pages_sign_SignView$$anon$16() {
}
export { $h_Lpresto_pages_sign_SignView$$anon$16 as $h_Lpresto_pages_sign_SignView$$anon$16 };
$h_Lpresto_pages_sign_SignView$$anon$16.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bX7;
});
$p.t = (function() {
  if ((!this.bX6)) {
    this.bX5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("page", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("x", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("y", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bX6 = true;
  }
  return this.bX5;
});
$p.ag = (function() {
  if ((!this.bX4)) {
    this.bX3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rw, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mH, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mH, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bX4 = true;
  }
  return this.bX3;
});
$p.v = (function() {
  if ((!this.bX9)) {
    this.bX8 = false;
    this.bX9 = true;
  }
  return this.bX8;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_sign_SignView$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_sign_SignView$$anon$16, "presto.pages.sign.SignView$$anon$16", ({
  X9: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_sign_SignView$$anon$16 as $d_Lpresto_pages_sign_SignView$$anon$16 };
//# sourceMappingURL=presto.pages.sign.-Sign-View$$anon$16.js.map
